var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripLiveview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1374 12.7899L15.5232 11.8255C15.5232 11.8255 16.0657 12.3454 16.6768 12.9318C17.3865 13.6129 17.7413 13.9534 18.0118 13.7988C18.2823 13.6441 18.173 13.1828 17.9542 12.2604C17.6215 10.8579 17.1125 9.50009 16.4372 8.21985C15.6424 6.7154 14.3548 5.52975 12.7901 4.86147L11.8253 4.47568C11.8253 4.47568 12.3176 3.96189 12.8857 3.36987C13.5839 2.64219 13.9331 2.27835 13.7795 2.00819C13.6259 1.73802 13.1497 1.84837 12.1974 2.06905C10.5254 2.45653 8.64191 3.12483 7.14279 4.27731C6.13035 5.02958 5.3416 6.04308 4.86103 7.20926L4.4753 8.17371C4.4753 8.17371 3.96244 7.6825 3.37113 7.11524C2.64243 6.41619 2.27808 6.06667 2.00795 6.22025C1.73781 6.37385 1.84831 6.85053 2.06931 7.80389C2.46383 9.50575 3.14929 11.4263 4.34021 12.9378C5.08443 13.9126 6.07454 14.672 7.20903 15.138L8.17418 15.5242C8.17418 15.5242 7.65405 16.0667 7.06755 16.6777C6.38718 17.3865 6.04699 17.7409 6.20163 18.0114C6.35628 18.282 6.81706 18.1728 7.73862 17.9543C9.12724 17.6251 10.4724 17.1234 11.7422 16.4589C13.2634 15.6643 14.463 14.3681 15.1374 12.7899Z",
    fill: "#172B4D",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripLiveview);
export default __webpack_public_path__ + "static/media/trip-liveview.d159a8b4ba380850faf2d2a6e9a5e060.svg";
export { ForwardRef as ReactComponent };